import Icon from '../components/Icon.vue'

Icon.register({
  'circle-notch': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 39.1c0-15.6 14.7-27.2 29.8-23.3 107.1 27.5 186.2 124.6 186.2 240.2 0 136.8-110.7 247.7-247.5 248-137.1 0.3-247.8-109.6-248.5-246.7-0.6-116.1 78.6-213.8 186-241.5 15.2-3.9 30 7.5 30 23.2v16.6c0 10.8-7.3 20.2-17.7 23.1-77.5 21.7-134.3 92.7-134.3 177.2 0 101.7 82.3 184 184 184 101.7 0 184-82.3 184-184 0-84.5-56.8-155.6-134.3-177.2-10.4-2.9-17.7-12.3-17.7-23.1v-16.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/circle-notch.js
// module id = 1195
// module chunks = 0